// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"78bbf2ef","717":"67bd186e","740":"114dfbee","909":"b3cb1051","975":"f8889bfc"}[chunkId] + ".chunk.js";
};